<template>
    <service-screen-layout :parts="parts">
        <template v-slot:points-contract>
            <div class="col-md-12">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label>Description</label>
                        <input type="text" class="form-control" v-model="saleDefinition.definition.pointsContract.description" disabled>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <label>Package</label>
                        <div class="input-group">
                            <input type="text" class="form-control" v-model="saleDefinition.definition.pointsContract.pointsPak.description" disabled>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </service-screen-layout>
</template>

<script>
import ServiceScreenLayout from "@/layouts/ServiceScreenLayout";

export default {
    components: {
        ServiceScreenLayout
    },
    data() {
        return {
            parts: [
                {
                name: "points-contract",
                icon: "fa-solid fa-file-contract",
                displayName: "Points Contract Details",
                permissions: ["*"],
                },
            ],
            saleNumber: null,
            saleDefinition: {
                definition: {
                    pointsContract: {
                        pointsPak: {
                            description: ""
                        }
                    }
                }
            },
        }
    },
    mounted() {
        this.saleNumber = this.$route.params.saleNumber;
        this.getSale();
    },
    methods: {
        getSale: function() {
            const hostUrl = this.$config.aimsAPI;

            this.$http.get(`${hostUrl}sales/definition/sale/${this.saleNumber}`).then(
                (response) => {
                    this.saleDefinition = response.data;               
                },
                (error) => {
                    console.error(error);
                    this.showError("Error fetching Sale Definition", error);
                }
            );
        },
    }
}
</script>

<style lang="scss" scoped>
.sale-button {
    text-align: left;
    cursor: pointer; 
    background-color: #edf1f2;

    &:hover {
        color: #1b72e2;
        border: 1px solid #1b72e2;
    }
}
</style>